import { Button, cn } from '@bridebook/aura';
import { Pencil } from '@bridebook/aura/src/icons';
import {
  useViewModeContainer,
  useViewModeEditMode,
} from '@bridebook/web/components/wedding-website/view-mode/view-mode.context';
import Link from 'next/link';
import { ComponentProps } from 'react';

type Props = Pick<ComponentProps<typeof Button>, 'onClick'> &
  Pick<Partial<ComponentProps<typeof Link>>, 'href'> & {
    className?: string;
  };

export const FloatingEditButton = ({ onClick, href, className }: Props) => {
  const editMode = useViewModeEditMode();
  const container = useViewModeContainer();

  const isLink = !!href && container === 'page';

  if (!editMode) return null;

  return (
    <div
      className={cn(
        'absolute right-2 bottom-2',
        // Only hide and show on hover for devices with fine pointer (mouse)
        // On coarse pointer devices (touch), buttons stay visible
        'opacity-100 [@media(pointer:fine)]:opacity-0 [@media(pointer:fine)]:transition-all [@media(pointer:fine)]:duration-150 [@media(pointer:fine)]:ease-in-out [@media(pointer:fine)]:group-hover:opacity-100',
        className,
      )}>
      <Button
        icon={Pencil}
        size={container === 'page' ? 'sm' : 'standard'}
        variant="secondary"
        asChild={isLink}
        className={cn(
          // Force icon-only size when rendered as link to keep circular shape
          isLink && (container === 'page' ? 'h-[32px] w-[32px]' : 'h-[40px] w-[40px]'),
        )}
        onClick={onClick}>
        {isLink && <Link href={href}></Link>}
      </Button>
    </div>
  );
};
